<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>公益课实时数据<span class="time">*当前页面数据是实时数据，刨除了取消进量数据。</span></h3>
        <div class="refresh">&nbsp;</div>
      </div>
      <div class="terms">
        <el-form :inline="true" label-position="left">
          <el-form-item label="选择学期：">
            <el-select :value="term_id" filterable placeholder="请选择学期" @change="handleTermsChange" no-data-text="还没有学期数据">
              <el-option v-for="item in terms" :key="item.id" :label="item.termTagName" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="statistics" >
        <li class="card">
          <div class="date">公益课人数</div>
          <div class="sum">{{ sum.get_account_num_str || '0' }}</div>
        </li>
        <li class="card">
          <div class="date">进群率</div>
          <div class="sum">{{ sum.enter_wechat_rate_str || '0' }}</div>
        </li>
        <li class="card">
          <div class="date">加微率</div>
          <div class="sum">{{ sum.add_wx_rate_str || '0' }}</div>
        </li>
        <li class="card">
          <div class="date">激活率</div>
          <div class="sum">{{ sum.active_rate_str || '0' }}</div>
        </li>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px" ref="searchForm">
        <el-form-item label="学校" prop="b2c_school_id">
          <el-select v-model="listQuery.b2c_school_id" filterable placeholder="请选择学校">
            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="年级" prop="b2c_grade_id">
          <el-select v-model="listQuery.b2c_grade_id" filterable placeholder="请选择年级">
            <el-option v-for="grade in gradeList" :key="grade.id" :label="grade.name" :value='grade.id' />
          </el-select>
        </el-form-item>
        <el-form-item label="班级" prop="b2c_class_name">
          <el-select v-model="listQuery.b2c_class_name" filterable placeholder="请选择班级">
            <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
        <el-button class="download_btn" type="primary" icon="el-icon-download" @click="downloadB2CTable">下载表格</el-button>
      </el-form>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row
        style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="学期" align="center">
          <template slot-scope="{row}">
            <span>{{ row.b2c_term_tag_name_concat || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学校" align="center">
          <template slot-scope="{row}">
            <span>{{ row.b2c_school_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年级" align="center">
          <template slot-scope="{row}">
            <span>{{ row.b2c_grade_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="班级" align="center">
          <template slot-scope="{row}">
            <span>{{ row.b2c_class_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公益课人数" align="center">
          <template slot-scope="{row}">
            <span>{{ row.get_account_num_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="进群率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.enter_wechat_rate_str }}</span>
          </template>
        </el-table-column>
        <el-table-column label="加微率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.add_wx_rate_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="激活率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.active_rate_str || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.index" :limit.sync="listQuery.pageSize"
        @pagination="getList" />
    </div>
  </power-wrapper>
</template>
<script>
import PowerWrapper from "@/components/PowerWrapper";
import Pagination from "@/components/Pagination/index";
import { getTeamCode, isCampus } from '@/utils/auth'
import { delUndefined } from '@/utils/utils';
import {
  apiGetB2CTermRealSum, apiGetB2CTermRealList, apiGetB2CTerms, apiGetB2CSchools, apiGetB2CGrades, apiGetB2CClasses, apiDownloadB2CSRealTimeTable,
  apiGetCampusTermRealSum, apiGetCampusTermRealList, apiDownloadCampusSRealTimeTable
} from "@/services/b2cStatement";

export default {
  name: 'fullLink',
  components: {
    Pagination,
    PowerWrapper,
  },
  props: {
  },
  computed: {
    tableHeader() {
      return { 'background-color': '#f5f5f5' }
    },
  },
  data () {
    return {
      list: [],
      terms: [],
      term_id: null,
      termDefault: null,
      currentTerm: null,
      statisticsArr: [],
      listLoading: false,
      schoolList: [],
      gradeList: [],
      classList: [],
      CurrRole: "B2C_PWcourse_Data",
      emptyText: '暂无数据',
      total: 0,
      sum: {},
      listQuery: {
        team_id: getTeamCode(),
        orderColumn: "b2c_term_tag_name",
        is_device: "1",
        orderType: "desc",
        b2c_term_tag_names: [],
        b2c_school_id: '',
        b2c_grade_id: '',
        b2c_class_name: '',
        index: 1,
        pageSize: 10,
      }
    }
  },
  created() {
    this.getTerms();
    this.getGrades();
    this.getClasses();
  },
  methods: {
    handleSearch() {
      this.getList();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
    },
    handleTermsChange(v) {
      const { terms } = this;
      const currentTerm = terms.find(item => item.id === v);
      this.term_id = v;
      this.currentTerm = currentTerm;
      this.listQuery.b2c_term_tag_names[0] = currentTerm.termTagName;
      this.getSchools(currentTerm.termIds);
      this.resetForm();
      this.handleQuery();
    },
    handleQuery() {
      this.getSum();
      this.getList('search');
    },
    async getSchools(termIds) {
      try {
        const res = await apiGetB2CSchools({ termIds });
        const { data = [], errCode } = res.data;
        if (errCode === 0) {
          this.schoolList = data;
        } else {
          this.schoolList = [];
        }
      } catch (error) {
        console.log(error);
        this.schoolList = [];
      }
    },
    async getGrades() {
      try {
        const res = await apiGetB2CGrades();
        const { data = [], errCode } = res.data;
        if (errCode === 0) {
          this.gradeList = data;
        } else {
          this.gradeList = [];
        }
      } catch (error) {
        console.log(error);
        this.gradeList = [];
      }
    },
    async getClasses() {
      try {
        const res = await apiGetB2CClasses();
        const { data = [], errCode } = res.data;
        if (errCode === 0) {
          this.classList = data;
        } else {
          this.classList = [];
        }
      } catch (error) {
        this.classList = [];
      }
    },
    async getTerms() {
      try {
        const res = await apiGetB2CTerms();
        const { data = [], errCode } = res.data;
        if (errCode === 0) {
          const term = data[0] || {};
          this.terms = data;
          this.handleTermsChange(term.id);
        } else {
          this.terms = [];
        }
      } catch (error) {
        console.log(error);
        this.terms = [];
      }
    },
    async getSum() {
      const {
        listQuery: {
          team_id,
          b2c_term_tag_names
        }
      } = this;
      const params = {
        team_id,
        b2c_term_tag_names
      }
      try {
        const res = await (isCampus() ? apiGetCampusTermRealSum(params) : apiGetB2CTermRealSum(params));
        const { data = [], errCode } = res.data;
        if (errCode === 0) {
          this.sum = data[0] || {};
        } else {
          this.sum = [];
        }
      } catch (error) {
        console.log(error);
        this.sum = [];
      }
    },
    async getList(btnName) {
      this.listLoading = true;
      const { listQuery } = this;
      const params = {
        ...listQuery,
      }
      if (btnName === 'search') {
        params.index = 1;
      }
      try {
        const res = await (isCampus() ? apiGetCampusTermRealList(delUndefined(params)) : apiGetB2CTermRealList(delUndefined(params)));
        const { data, errCode, total } = res.data;
        if (errCode === 0) {
          this.listLoading = false;
          this.list = data;
          this.total = total;
        } else {
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      } catch (error) {
        console.log(error);
        this.listLoading = false;
        this.list = [];
        this.total = 0;
      }
    },
    downloadB2CTable() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)",
      });
      const params = {
        ...this.listQuery,
        pageSize: this.total,
      };
      (isCampus() ? apiDownloadCampusSRealTimeTable(params) : apiDownloadB2CSRealTimeTable(params))
        .then((res) => {
          setTimeout(() => {
            this.loading.close();
          }, 1000);
          const { data, errCode } = res.data;
          if (errCode === 0 && data) {
            const downloadElement = document.createElement("a");
            downloadElement.href = data;
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            this.loading.close();
          }, 1000);
          this.$message({ type: "error", message: error });
        });
    },
  }
}
</script>
<style lang="less" scoped>
@import '../../styles/common.less';
.download_btn {
  float: right;
  margin: 3px auto 30px 20px;
}
</style>
